import { Button } from "@/components/ui/button"
import { Trash2 } from "lucide-react"
import { useAppSelector } from "@/reducers/hooks"
import { findRoute2g } from "@/reducers/routes2gSlice"
import { DriverContext } from "@/contexts/DriverContext"
import { useCallback, useContext } from "react"
import { useTranslation } from "react-i18next"

const ClearRouteButton = ({ className }: { className?: string }) => {
  const { t } = useTranslation()
  const { clearRoute2g, routeJid } = useContext(DriverContext)

  const handleClearRoute = useCallback(async () => {
    if (routeJid) {
      await clearRoute2g(routeJid)
    }
  }, [clearRoute2g, routeJid])

  const route = useAppSelector(findRoute2g(routeJid?.toString()))

  if (!routeJid || !route || (route.stops && route.stops.length === 0))
    return null

  return (
    <div className={className}>
      <Button
        variant="outline"
        size="sm"
        onClick={handleClearRoute}
        className="rounded-md border px-4 py-2 text-left font-normal hover:bg-blue-100 dark:hover:bg-blue-800"
        title={t("maps.clearRouteButton.title")}
      >
        <Trash2 />
      </Button>
    </div>
  )
}

export default ClearRouteButton
